export const EN = {
    primitive: {
        thousandSeparator: ",",
        decimalSeparator: ".",
    },
    numberSuffix: {
        billion: "bn",
        million: "m",
    },
    pager: {
        page: "Page:",
        linesPerPage: "Lines per page:",
        linesFromTo: (from, to, total) => `${from} - ${to} of ${total}`,
    },
    error: {
        confirmButton: "Close",
        defaultTitle: "Error",
        defaultHint: "An unexpected error occurred. Your request could not be processed at this time. ",
        serverError: "Please try again later.",
        networkError: "Couldn't connect to the 21st platform. Please check your network connection and try again later.",
        messageWithFlowId: (flowId) => `We have assigned this error the ID ${flowId} and will investigate.`,
    },
    breadcrumb: {
        title: "You are here",
    },
    validation: {
        textTooLong: (maxAllowed) => `Please enter only up to ${maxAllowed} characters.`,
        textTooShort: (minRequired) => `Please enter at least ${minRequired} characters.`,
        date: {
            formatMismatch: (format) => `The given date does not match the expected format (${format}).`,
        },
        notANumber: "Please enter a number.",
        required: "Please enter a value.",
        min: (min) => `Value too small (expected ≥ ${min}).`,
        max: (max) => `Value too big (expected ≤ ${max}).`,
        integer: "Please enter an integer.",
    },
    offerState: {
        notyetcompleted: "Not complete",
        published: "Published",
        publishedincomplete: "Recorded",
        cannotvaluate: "Could not be valuated",
        readybutcannotvaluate: "Ready to publish, but could not be valuated",
        readytopublish: "Ready to publish",
        ownoffer: "Own offer",
        nostatepresent: "Neither previous knowledge nor first record",
        firstrecord: "First Record sent",
        previousknowledge: "Previous Knowledge declared",
        onbehalfof: "Recorded Offer",
    },
    revoHeader: {
        backButton: "Back",
    },
};
//# sourceMappingURL=en.js.map